import Accordion from 'components/Accordion';
import Link from 'components/Link';
import SectionHeader from 'components/SectionHeader';
import Table from 'components/Table/TableStatic';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import Truncator from 'components/Truncator';
import {SendDocument} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {jt, t} from 'ttag';

const HELP_CENTER_URL =
    'https://help.makeleaps.jp/ja/articles/10511146#h_d3541ad22a';

type SendViaPeppolSendStatusProps = {
    isSelected: boolean;
    sentDocumentSet?: SendDocument[];
};

const SendViaPeppolSendStatus: FC<SendViaPeppolSendStatusProps> = ({
    isSelected,
    sentDocumentSet,
}) => {
    if (!isSelected) {
        return null;
    }

    const helpCenterLink = (
        <Link
            aria-label="help-center"
            href={HELP_CENTER_URL}
            isOpenInNewTab={true}
        >
            {t`Help Center`}
        </Link>
    );

    return (
        <div className="flex flex-col gap-4">
            <SectionHeader level={2} title={t`Peppol Send`} />
            <Accordion
                hasBorderWhenExpanded={false}
                header={t`Status`}
                isOpenByDefault={true}
            >
                <div className="flex flex-col gap-4">
                    <div aria-label="Status for Peppol Send">{jt`Peppol Send cannot be cancelled. For more details, see the ${helpCenterLink} (Japanese site).`}</div>
                    {sentDocumentSet && (
                        <Table classNameTable="table-fixed">
                            <Table.Header>
                                <Table.HeaderRow>
                                    <Table.Column className="w-1/2">{t`Document`}</Table.Column>
                                    <Table.Column className="flex w-1/2 items-center gap-2">
                                        {t`Status`}
                                        <TooltipIcon
                                            href="https://help.makeleaps.jp/ja/articles/10511146#h_30cff783e7"
                                            message={t`What is “Status”?`}
                                            size="base"
                                        />
                                    </Table.Column>
                                </Table.HeaderRow>
                            </Table.Header>
                            <Table.Body>
                                {sentDocumentSet.map((data) => (
                                    <Table.Row key={data.mid}>
                                        <Table.Cell>
                                            <Truncator text={data.document} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Truncator
                                                text={data.displayStatus}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    )}
                </div>
            </Accordion>
        </div>
    );
};
export default SendViaPeppolSendStatus;
